import React from 'react';
import PropTypes from 'prop-types';
import styles from './style.module.css';
import { FSF_logo, forgotPassword_lock } from 'assets/icons';
import Header from './Header';
import MobileHeader from './MobileHeader';
const SignUpLayoutNew = ({ children, width, height, isMobile, headerName }) => {
  const mobClassName = isMobile ? styles.mob : '';
  return (
    <div className={styles.background}>
      <div className={`${styles.blackOverlay} ${mobClassName}`}>
        <div className={`${styles.header} ${isMobile ? styles.mob : ''}`}>
          <MobileHeader headerName={headerName} />
          <Header />
        </div>
        {!isMobile && headerName === 'Send One-Time Login Link' && (
          <p className={styles.pageTitle}>{headerName}</p>
        )}

        <div className={`${styles.wrapper} ${mobClassName}`}>
          <div
            style={{ height, width }}
            className={`${styles.formWrapper} ${mobClassName}`}
          >
            <img
              alt=""
              src={
                headerName === 'Forgot Password' ||
                headerName === 'Forgot Password Email Sent'
                  ? forgotPassword_lock
                  : headerName === undefined
                  ? FSF_logo
                  : FSF_logo
              }
              className={`${styles.logo} ${mobClassName}`}
            />
            <div className={styles.childrenDiv}>{children}</div>
          </div>
        </div>
      </div>
    </div>
  );
};

SignUpLayoutNew.propTypes = {
  children: PropTypes.element.isRequired,
};

export default SignUpLayoutNew;
